import { motion } from "framer-motion";

const socials = [
  { label: "Instagram", href: "https://noisetrance.dance" },
  { label: "SoundCloud", href: "https://noisetrance.dance" },
  { label: "Bandcamp", href: "https://noisetrance.dance" },
];

export const Transmission = () => {
  return (
    <footer id="transmission" className="relative bg-ink border-t border-line" data-testid="transmission-section">
      <div className="px-5 sm:px-8 lg:px-12 py-20 sm:py-28">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-6 font-mono text-xs uppercase tracking-[0.3em] text-acid"
        >
          / Next Transmission
        </motion.div>

        <motion.a
          href="https://noisetrance.dance"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="transmission-cta"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="group block"
        >
          <h2 className="font-display font-black uppercase text-bone leading-[0.85] tracking-tighter text-[13vw] sm:text-[11vw] group-hover:text-acid transition-colors duration-500">
            Tune in↗
          </h2>
        </motion.a>

        <p className="mt-6 font-mono text-sm sm:text-base text-bone/60 max-w-lg leading-relaxed">
          Releases, mixes and event drops land first on the label. No mailing
          list, no noise — just the transmission.
        </p>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-12 gap-8 border-t border-line pt-10">
          <div className="sm:col-span-4">
            <span className="font-display font-black uppercase text-bone text-xl tracking-tighter">
              zi<span className="text-acid">.</span>enzi
            </span>
            <p className="mt-2 font-mono text-xs uppercase tracking-widest text-bone/40">Bristol · UK</p>
          </div>

          <div className="sm:col-span-4 flex flex-col gap-2">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`social-${s.label.toLowerCase()}`}
                className="font-mono text-xs uppercase tracking-widest text-bone/60 hover:text-acid transition-colors duration-300 w-fit"
              >
                {s.label} ↗
              </a>
            ))}
          </div>

          <div className="sm:col-span-4 sm:text-right">
            <a
              href="https://noisetrance.dance"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-noisetrance"
              className="font-mono text-xs uppercase tracking-widest text-acid hover:text-blood transition-colors duration-300"
            >
              noisetrance.dance ↗
            </a>
            <p className="mt-2 font-mono text-[10px] uppercase tracking-widest text-bone/30">
              © 2026 — all frequencies reserved
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Transmission;
